import type { CompetitorOddsWithStatus } from 'app/pages/EventsPage/types';

// Logic explained here : https://git.pandascore.co/PandaScore/panda-odds/hashi/-/merge_requests/111
const getCompetitorStatus = (competitor: CompetitorOddsWithStatus): CompetitorStatus =>
  competitor.match_status ?? competitor.scrapper_status ?? 'down';

const isCompetitorDisplayed = (
  userSettings: CompetitorSlug[] | undefined,
  competitor: CompetitorSlug
): boolean => {
  const competitorSlugToCheck: CompetitorSlug =
    competitor === 'pandaodds-limited' || competitor === 'pandaodds-helper-model'
      ? 'pandaodds'
      : competitor;
  return !!userSettings?.includes(competitorSlugToCheck);
};

const isMatch2WayCompetitorDisplayed = (
  market: CompetitorMarketState,
  shouldDisplay: boolean | undefined
) => shouldDisplay || !(market.template === 'winner-2-way' && market.event_type === 'match');

export { getCompetitorStatus, isCompetitorDisplayed, isMatch2WayCompetitorDisplayed };
